import type { TOC } from '@ember/component/template-only'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { or } from 'ember-truth-helpers'

interface Signature {
  Element: HTMLElement
  Args: {
    title: string
    borderAccentClass?: string
  }
  Blocks: { default: [] }
}

export class TeacherHomeWidgetCard extends Component<Signature> {
  get borderAccentClass() {
    return this.args.borderAccentClass ?? 'border-t-3E-blue-300'
  }

  <template>
    <section
      class="border-x-neutral-75 border-b-neutral-75 flex h-full flex-col overflow-hidden rounded-2xl border-x border-t-4 border-b bg-white shadow-sm
        {{this.borderAccentClass}}"
    >
      <div class="border-b border-b-neutral-100 px-4 py-2.5">
        <h2 class="text-base font-semibold text-nowrap text-neutral-400">
          {{@title}}
        </h2>
      </div>

      <div class="flex min-h-0 flex-1 flex-col" ...attributes>
        {{yield}}
      </div>
    </section>
  </template>
}

interface WidgetContentSignature {
  Element: HTMLDivElement
  Blocks: { default: [] }
}

export const WidgetContent: TOC<WidgetContentSignature> = <template>
  <div class="flex-1 px-4 py-3" ...attributes>
    {{yield}}
  </div>
</template>

interface NoDataStateSignature {
  Element: HTMLParagraphElement
  Args: {
    body?: string
  }
}

export const WidgetNoDataMessage: TOC<NoDataStateSignature> = <template>
  <p data-test-no-data-message class="flex-1 content-center p-4 text-center font-bold">
    {{or @body (t "teacherHome.widgets.noData")}}
  </p>
</template>

export default TeacherHomeWidgetCard
